import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you've set the `}<a parentName="p" {...{
        "href": "/docs/libraries/flutter#person-profiles-anonymous-vs-identified-persons"
      }}><inlineCode parentName="a">{`personProfiles`}</inlineCode>{` config`}</a>{` to `}<inlineCode parentName="p">{`IDENTIFIED_ONLY`}</inlineCode>{` (the default option), anonymous events are captured by default. Then, to capture identified events, call any of the following functions:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/product-analytics/identify"
        }}><inlineCode parentName="a">{`identify()`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/product-analytics/identify#alias-assigning-multiple-distinct-ids-to-the-same-user"
        }}><inlineCode parentName="a">{`alias()`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/product-analytics/group-analytics"
        }}><inlineCode parentName="a">{`group()`}</inlineCode></a></li>
    </ul>
    <p>{`When you call any of these functions, it creates a `}<a parentName="p" {...{
        "href": "/docs/data/persons"
      }}>{`person profile`}</a>{` for the user. Once this profile is created, all subsequent events for this user will be captured as identified events.`}</p>
    <p>{`Alternatively, you can set `}<inlineCode parentName="p">{`personProfiles`}</inlineCode>{` to `}<inlineCode parentName="p">{`ALWAYS`}</inlineCode>{` to capture identified events by default.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      